import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20e46ebc")

_pushScopeId("data-v-20e46ebc")
const _hoisted_1 = { class: "select-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "Organization Select", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Select All")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Deselect All")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "v-select-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (
        _ctx.fetchState === _ctx.FetchStates.UNFETCHED ||
          _ctx.fetchState === _ctx.FetchStates.FETCHING
      )
      ? (_openBlock(), _createBlock("div", _hoisted_3, " Loading... "))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", null, [
            _createVNode(_component_el_button, { onClick: _ctx.selectAllOrgs }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.deselectAllOrgs }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_el_select, {
              multiple: "",
              filterable: "",
              modelValue: _ctx.activeOrgIds,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeOrgIds = $event)),
              class: "v-select",
              placeholder: "Select Organizations"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orgs, (org) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: org.id,
                    label: org.name,
                    value: org.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
  ]))
})